








































import Vue from 'vue';
import {Component} from 'vue-property-decorator';

import {AppConstants} from '@app/store/AppConstants';
import {PageContent} from '@app/store/models/PageContent';

import CubPageContent from '@app/common/PageContent.vue';

@Component({
    components: {CubPageContent}
})
export default class Connect extends Vue {

    get pageContent(): PageContent | null {
        return this.$store.getters.pageContent('connect');
    }

    public contact: {[field: string]: string} = this.resetForm();

    public messageSent = false;
    public submitted = false;

    public handleSubmit(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        this.submitted = true;

        const form = event.target as HTMLFormElement;

        this.messageSent = form.checkValidity();

        if (this.messageSent) {
            fetch(`${AppConstants.apiUrl}/contact`, {
                method: 'POST',
                headers : new Headers(),
                body: JSON.stringify(this.contact)
            }).then((res) => res.json())
                .then(() =>  {
                    this.resetForm();
                    this.submitted = false;
                })
                .catch((err) => console.error(err))
        }
    }

    private resetForm(): {[field: string]: string} {
        return {
            name: '',
            email: '',
            message: '',
            test: ''
        }
    }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/connect/Connect.vue